import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
} from "@mui/material";
import { FC } from "react";
import { Option } from "types/option";

type MultipleChoiceSelectorProps = {
  value: number[];
  onChange?: (value: number[]) => void;
  options: Option[];
};

export const MultipleChoiceSelector: FC<MultipleChoiceSelectorProps> = ({
  value = [],
  onChange,
  options,
}) => {
  const sortedOptions = [...options].sort((a, b) => (a.order || 0) - (b.order || 0));

  const handleChange = (index: number, checked: boolean) => {
    if (checked) {
      onChange?.([...value, index]);
    } else {
      onChange?.(value.filter((v) => v !== index));
    }
  };

  return (
    <Box sx={{ mt: 1 }}>
      <FormGroup>
        {sortedOptions.map((opt, index) => (
          <FormControlLabel
            key={opt.option_id || index}
            control={
              <Checkbox
                checked={value.includes(index)}
                onChange={(e) => handleChange(index, e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body1" sx={{ ml: 1 }}>
                {opt.text}
              </Typography>
            }
            sx={{ mb: 1, alignItems: "flex-start" }}
          />
        ))}
      </FormGroup>
    </Box>
  );
};
